<template>
  <div class="BaseInfo-root">
    <!-- <appGetAddressDetails :default-province="province" :default-address="address" @updateData="getAddress" /> -->
    <!-- <demo /> -->
    <div v-if="noData" class="no-data">暂未派车，请派车后查看</div>

    <div v-if="!noData">
      <div class="info-panel-first">
        <div class="car-info">
          <a
            v-for="(item, index) in dispatchList"
            :key="index"
            :class="['carBtn', carActIndex === index ? 'active' : '']"
            @click="carActIndex = index"
          >
            {{ item.licensePlate }}
          </a>
          <a-descriptions bordered :column="3" class="info-panel descriptions-info">
            <a-descriptions-item label="派车单号">
              {{ form.shippingOrderNo }}
            </a-descriptions-item>
            <a-descriptions-item label="司机姓名">
              {{ form.driverName }}
            </a-descriptions-item>
            <a-descriptions-item label="司机电话" :span="2">
              {{ form.driverPhone }}
              <a class="show-phone" @click="showPhone(form.driverPhone)">查看号码</a>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="司机类型">
              {{ form.driverType | driverTypeFilter }}
            </a-descriptions-item> -->
            <a-descriptions-item label="车牌号">
              {{ form.licensePlate }}
            </a-descriptions-item>
            <a-descriptions-item label="车型">
              {{ form.carType || '--' }}
            </a-descriptions-item>
            <!-- <a-descriptions-item label="车辆所属">
              {{ form.carOwningSideName }}
            </a-descriptions-item> -->
          </a-descriptions>
        </div>
        <car-line-or-goods v-if="carShow" :is-demo-data="isDemoData" class="info-panel" :data="waybillList" :order-goods-type="orderGoodsType" />
      </div>


      <map-gps
        class="info-panel"
        :waybill-list="waybillList"
        :start-time="form.startTransportTime"
        :order-data="form"
        :is-demo="isDemo"
        :is-demo-data="isDemoData"
        :dispatch="dispatchList && dispatchList.length > 0 ? dispatchList[carActIndex] : {}"
      />

      <car-temperature
        v-if="showTemperature"
        ref="carTemperature"
        class="info-panel"
        :waybill-list="waybillList"
        :start-time="form.startTransportTime"
        :vehicle="form.licensePlate"
        :driver-phone="form.driverPhone"
      />
    </div>
  </div>
</template>

<script>
import base from '@/api/base'
import { batchDispatchInfo } from "@/pages/orderManage/api.js";
import { DriverTypeText } from "@/pages/orderManage/constant.js";
import { mapActions } from 'vuex'
// import appGetAddressDetails from '@/components/app-get-address-details'
// import InfoBox from "./components/InfoBox";
import { Modal } from 'ant-design-vue';
import {RULE_TYPE} from '@/constants/ruleConfig'
import CarLineOrGoods from "./components/CarLineOrGoods";
import MapGps from "./components/CarGps.vue";
import CarTemperature from "./components/CarTemperature";
import {featchOrderDetail} from '../api.js'
// import demo from "./components/demo";
// import Demo from '@/pages/demo/Demo.vue';
export default {
  name: "CarInfo",
  components: {
    // InfoBox,
    CarLineOrGoods,
    MapGps,
    CarTemperature,
    // demo,
    // Demo
    // appGetAddressDetails
  },
  filters: {
    driverTypeFilter(val) {
      return DriverTypeText[val];
    },
  },
  props: {
    orderStatus: {
      type: String,
      default: "",
    },
    orderDetail: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      carActIndex: null,

      dispatchList: [],

      form: {
        shippingOrderNo: "",
        driverName: "",
        driverPhone: "",
        realDriverPhone: "",
        driverType: "",
        licensePlate: "",
        createTime: "",
      },
      orderNo: this.$route.query.unifyOdrNo,
      // address: "",
      // province: [],
      noData: true,
      // orderDetail: {},
      carShow: true,
      orderGoodsType: 0,
      showTemperature: false,
      isDemo: false,
      orderList: [],
    };
  },
  computed: {
    isDemoData() {
      return this.orderDetail.ext?.demoData || false
    },
    waybillList() {
      return this.form.waybillList || [];
    },
  },
  watch: {
    carActIndex: {
      handler(val) {
        this.$nextTick(() => {
          const info = this.dispatchList[val] || {};
          const { driverName = '' } = info;
          this.form = {
            ...info,
            driverName: this.orderDetail.ext?.demoData ? `${driverName.slice(0, 1)}师傅` : driverName,
          }
        })
      },
    },
    dispatchList(val){
      if(val.length === 0){
        this.noData = true
      }else{
        this.noData = false
      }
    },
  },
   async created() {
    await this.getOrderCrop(RULE_TYPE.sensitiveFields)
    const showTemperatureList = JSON.parse(localStorage.getItem('showTemperatureList') || '[]')
    const { customerCode } = this.$store.state.user
    this.showTemperature = showTemperatureList.includes(customerCode)
    this.featchData()
    // 演示账号名单获取
    base.getDictionary({
        status: 1,
        type: 'customer_test_tenant',
    }).then((res) => {
      res.forEach((e) => {
        if(e.dictionaryCode === customerCode){
            this.isDemo = true
        }
      })
    })
  },
  mounted() {
  },
  methods: {
    ...mapActions('orderRules', ['getOrderCrop']),
    // 虚拟拨号
    async showPhone() {
      const {dispatchList, carActIndex} = this
      const res = await batchDispatchInfo({
        orderNos: this.orderList,
      }, {id: dispatchList[carActIndex].id, params:["driverPhone"], isAxn: true})
      if (res.secretNo) {
        Modal.info({
          title: () => '',
          width: 450,
          okText: '确认',
          icon: '',
          okType: 'link',
          maskClosable: true,
          class: 'phone-modal',
          content: h => h('div', {}, [
            h('p', '联系司机请拨打以下手机号，手机号将在2分钟内有效'),
            h('p', {class: 'tel-phone'}, res.secretNo),
          ]),
          onOk() {
          },
        });
      } else {
        this.$message.error(res)
      }
    },
    async featchData(){
      const orderList = []
      if (this.orderDetail.orderMsgResList?.length)
      this.orderDetail.orderMsgResList.forEach(item => {
        orderList.push(item.odrNo)
      })
      this.orderList = orderList
      if(orderList.length) {
        const res = await batchDispatchInfo({ orderNos: orderList });
        this.dispatchList = res
        this.carActIndex = 0;
      }
    },
    getAddress() {
    },
    async getOrderDetail() {
      this.orderDetail = await featchOrderDetail({
          unifyOdrNo: this.$route.query.unifyOdrNo
      })
      this.carShow = true
      this.orderGoodsType = this.orderDetail.ext.orderGoodsType
    }
  },
};
</script>

<style lang="less" scoped>
.info-panel {
  margin-top: 10px;
}
.info-panel-first {
  padding: 30px 0 20px 0;
  background-color: #fff;
  .ant-btn {
    margin-right: 10px;
  }
  .car-info {
    padding: 0 20px;
  }
}
.no-data {
  padding: 100px 0 500px;
  text-align: center;
  font-size: 24px;
  color: #ccc;
  background: #fff;
  // margin-top: 20px;
}
.carBtn{
  border: none;
  display: inline-block;
  width: 108px;
  height: 40px;
  background-size: 100% 100%;
  text-align: center;
  line-height: 40px;
  color: #606266;
  margin-right: 16px;
  background-image: url('../../../assets/img/offcar_icon.png');
  &.active {
    color: #fff;
    background-image: url('../../../assets/img/oncar_icon.png');
  }
}
/deep/ .ant-table-thead{
  background: #fafafa;
}
.show-phone {
  margin-left: 12px;
}
</style>


<style lang="less">
.phone-modal {
  .ant-modal {
    text-align: center;
    .anticon-question-circle {
      display: none;
    }
    .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
      margin: 0;
    }
    .ant-modal-confirm-btns {
      float: none;
    }
  }
  .tel-phone {
    font-size: 24px;
    font-weight: 500;
  }
}
</style>
